import { waitWithData } from '@/utils/sleep';
import { mockCompaniesList } from './mockData';

export class CompaniesApi {
  getList() {
    return waitWithData(mockCompaniesList, 500);
  }
}
